import { createSelector } from "reselect"
import { get } from "lodash"

const getFeatures = state => get(state, "global.data.enabledFeatures.data", false)

export const getIsDashboardEnabled = createSelector(
  [getFeatures],
  (features) => get(features, "dashboard", false),
)

export const getIsIntradayFeatureEnabled = createSelector(
  [getFeatures],
  (features) => get(features, "dashboard_intraday", false),
)

export const getIsRfrAttributionEnabled = createSelector(
  [getFeatures],
  (features) => get(features, "rfr_attribution", false),
)

export const getIsIntradayAnalyticsEnabled = createSelector(
  [getFeatures],
  (features) => get(features, "intraday_analytics", false),
)

export const getIsBenchmarkEnabled = createSelector(
  [getFeatures],
  (features) => get(features, "benchmark_data_type", false),
)
